import React, { FC, useEffect } from 'react';
import { Wrapper } from './styles';
import { Header, LayoutComponent } from './components';
import { useParams } from 'react-router-dom';
import { getSecretaryById } from 'applicaiton/store/reducers/Secretaries/ActionCreators';
import { setHasUnsavedChanges } from 'applicaiton/store/reducers/DetectChangesSaved/DetectChangesSavedSlice';
import { resetSecretaryData } from 'applicaiton/store/reducers/Secretaries/SecretariesSlice';
import { useAppDispatch } from 'common/hooks/redux';
import ProfileInfo from './components/ProfileInfo';
import { useSubscription } from 'common/hooks/useSubscription';
import SubscriptionsBlocked from 'common/components/SubscriptionsBlocked';
import SubscriptionsExpiredSoon from 'common/components/SubscriptionsExpiredSoon';

const SecretaryEdit: FC = () => {
  const { id } = useParams();
  const dispatch = useAppDispatch();
  const { isExpiredSoon, isBlocked } = useSubscription();

  useEffect(() => {
    dispatch(getSecretaryById(id!));

    return () => {
      dispatch(setHasUnsavedChanges(false));
      dispatch(resetSecretaryData());
    };
  }, []);

  if (isBlocked) {
    return <SubscriptionsBlocked />;
  }

  return (
    <Wrapper>
      {isExpiredSoon && <SubscriptionsExpiredSoon />}
      <Header />

      <LayoutComponent>
        <ProfileInfo />
      </LayoutComponent>
    </Wrapper>
  );
};

export default SecretaryEdit;
